import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'
import { path } from 'ramda'

const usuariosRepository = createRepository({
  path: 'usuarios',
  restApi,
  queryTransform: {
    usuario: query.ilike('usuario'),
    realm: query.eq('realm'),
    ...paginate
  },
  getErrorMessage: response => path(['data', 'error', 'message'], response)
})

usuariosRepository.getMe = async () => {
  const response = await restApi.get('usuarios/me')
  if (response.ok) {
    return response.data
  }
}

usuariosRepository.listGestoresByCentroCusto = ({
  centroCustoId,
  usuario,
  order,
  limit
}) => {
  return restApi.get(
    `centros-custo/${centroCustoId}/gestores?${
      usuario
        ? `filter[where][usuario][ilike]=%${usuario.split('').join('%')}%`
        : ''
    }&filter[order]=${order}&filter[limit]=${limit}`
  )
}

usuariosRepository.listAnalistasAdmin = ({ usuario, order, limit }) => {
  const filter = {
    where: {
      and: [
        { usuario: { ilike: `%${usuario.split('').join('%')}%` } },
        {
          or: [
            { realm: 'analista' },
            { realm: 'analista_2' },
            { realm: 'admin' }
          ]
        }
      ]
    },
    order,
    limit
  }
  return restApi.get('/usuarios', { filter })
}

usuariosRepository.listAnalistasOpAdmin = ({ usuario, order, limit }) => {
  const filter = {
    where: {
      and: [
        { usuario: { ilike: `%${usuario.split('').join('%')}%` } },
        {
          or: [
            { realm: 'analista_op' },
            { realm: 'analista_op_2' },
            { realm: 'admin' }
          ]
        }
      ]
    },
    order,
    limit
  }
  return restApi.get('/usuarios', { filter })
}

usuariosRepository.loadAnalistasAnalistasOpAdmin = ({
  usuario,
  order,
  limit
}) => {
  const filter = {
    where: {
      and: [
        { usuario: { ilike: `%${usuario.split('').join('%')}%` } },
        {
          or: [
            { realm: 'analista' },
            { realm: 'analista_2' },
            { realm: 'analista_op' },
            { realm: 'analista_op_2' },
            { realm: 'admin' }
          ]
        }
      ]
    },
    order,
    limit
  }
  return restApi.get('/usuarios', { filter })
}

usuariosRepository.listAnalistas = ({ usuario, order, limit }) => {
  const filter = {
    where: {
      and: [
        { usuario: { ilike: `%${usuario.split('').join('%')}%` } },
        { or: [{ realm: 'analista' }, { realm: 'analista_2' }] }
      ]
    },
    order,
    limit
  }
  return restApi.get('/usuarios', { filter })
}

usuariosRepository.listAnalistasOp = ({ usuario, order, limit }) => {
  const filter = {
    where: {
      and: [
        { usuario: { ilike: `%${usuario.split('').join('%')}%` } },
        { or: [{ realm: 'analista_op' }, { realm: 'analista_op_2' }] }
      ]
    },
    order,
    limit
  }
  return restApi.get('/usuarios', { filter })
}

usuariosRepository.patch = (id, data) => restApi.patch(`usuarios/${id}`, data)

export default usuariosRepository
